import _ from '../../core/utils'

const API_PAGE_STATUS_CONFIG = {
    forms: _.selectAll( '.form--page-status' ),
    edit: _.select( '.fl__edit-page' ),
    editPublish: _.select( '.fl__edit-status--publish' ),
    editUnpublish: _.select( '.fl__edit-status--unpublish' ),
    pages: _.selectAll( '.fl__page' ),
    endpoint: 'page/status/'
}
export default API_PAGE_STATUS_CONFIG